import { render, staticRenderFns } from "./BasketballPool.vue?vue&type=template&id=829c0bf6&scoped=true"
import script from "./BasketballPool.vue?vue&type=script&lang=js"
export * from "./BasketballPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829c0bf6",
  null
  
)

export default component.exports